import { KeyboardEvent, MouseEvent } from "react";

import { MessageSeverity } from "primereact/api";

import { ToastStore } from "../../stores/ToastStore";
import { translationKeys } from "../app-translation-keys";

export const copyTextToClipboard = (
  event: MouseEvent | KeyboardEvent,
  textToCopy: string,
  textTypeDescription: string,
  toastStore: ToastStore,
) => {
  event.stopPropagation();
  event.preventDefault();

  const clipboardTranslationKeys = translationKeys.toast.copyToClipboard;

  navigator.clipboard
    .writeText(textToCopy)
    .then(() => {
      toastStore.addToast({
        severity: MessageSeverity.SUCCESS,
        summary: {
          translationKey: clipboardTranslationKeys.summarySuccess,
        },
        detail: { translationKey: clipboardTranslationKeys.detailSuccess, translationParams: { textTypeDescription } },
        life: 3000,
      });
    })
    .catch(() => {
      toastStore.addToast({
        severity: MessageSeverity.ERROR,
        summary: {
          translationKey: clipboardTranslationKeys.summaryError,
        },
        detail: { translationKey: clipboardTranslationKeys.detailError },
        life: 3000,
      });
    });
};
